<!--
File Name          : learning-layout.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="component-container">
    <div class="remaining-container">
        <div *ngIf="devices.length < 1; else lessonCards" class="first-device-container card-position standard-center-card">
            <img class="device-logo" src="/assets/RemoveSensor_Icon.svg" alt="No sensor connected">
            <dx-button text="Pair Motion Sensor" type="default" (onClick)="addLessonCard()"></dx-button>
        </div>

        <ng-template #lessonCards>
            <div [class]="'card-position standard-center-card' + (devices[0].status == 'DISPLAYING' ? ' results-displaying-card' : '')">
                <app-data-collection [device]="devices[0]" [subs]="unit!.subs">
                            
                    <div results>
                        <ng-container *ngComponentOutlet="lessonComponent; inputs: lessonInputs()"></ng-container>
                    </div>    
                </app-data-collection>
            </div>

            <!-- <div class="lesson-card-container">
                <div class="lesson-card" *ngFor="let device of devices">
                    <div [style]="{
                        height: '36px', 
                        width: '36px', 
                        borderRadius:'18px', 
                        backgroundColor: device.deviceColor,
                        position: 'absolute',
                        top: '4px',
                        left: '4px'
                        }"></div>
                    <dx-button style="position:absolute;top:4px;right:4px;" icon="trash" type="danger" (onClick)="removeDevice(device)"></dx-button>
                    <div class="results-container">
                        
                    </div>
                </div>
            </div> -->
            <!-- <dx-button 
                *ngIf="devices.length < 4" 
                style="position:absolute; top: 12px; right: 16px;" 
                text="Add Device" 
                type="normal"
                stylingMode="outlined"
                (onClick)="addLessonCard()"
            ></dx-button> -->
        </ng-template>
    </div>
    
    
</div>
